









































import { defineComponent, ref, watch } from '@vue/composition-api';
import { ubtSetupModuleExpose } from '@/shared/utils/ubt/ubt-setup';
import router from '@/router';
import platform from '@/shared/utils/platform';
import { Navbar } from '@hb/coffee';
import { getStatusBarHeight, goBack, setStatusBar } from '@/api/native/utils';
import { DEFAULT_STATUSBAR_HEIGHT } from '@/constant';
import { useNavbarHeight } from './useNavbarHeight';

export default defineComponent({
  components: {
    Navbar,
  },
  props: {
    isCustomBackEvent: {
      type: Boolean,
      default: false,
    },
    titleIsCenter: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: '',
    },
  },
  emits: ['back'],
  setup(props, context) {
    const navbarRef = ref();
    const androidStatusHeight = ref(DEFAULT_STATUSBAR_HEIGHT);

    // 获取安卓状态栏高度
    getStatusBarHeight().then((height) => {
      androidStatusHeight.value = height;
    });

    useNavbarHeight(navbarRef);

    const handleBack = async () => {
      ubtSetupModuleExpose('finance_commonNavbar_pageExit', {
        currentPage: router.currentRoute.path,
      });

      /** 若是“自定义back“使用场景，则对外emit事件 */
      if (props.isCustomBackEvent) {
        context.emit('back');
      } else {
        // TODO: 跳转特殊处理逻辑暂未实现，后续其他页面接入后再补充
        goBack();
      }
    };

    watch(
      () => router.currentRoute.path,
      (newPath, oldPath) => {
        if (newPath !== oldPath) {
          /** 设置安卓状态栏 */
          if ((platform.isAndroid || platform.isHarmony) && platform.isHelloApp) {
            const {
              statusBarBackground = 'transparent',
              isDarkStatusBar = true,
            } = router.currentRoute.meta.navbar || {};
            const statusBarParams = {
              // 状态栏颜色-背景色
              colorCode: statusBarBackground,
              // 是否显示状态栏, 安卓统一为不显示，避免h5导航栏闪动问题
              isShowStatusBar: false,
              // true深色文字, false浅色文字
              isDarkFont: isDarkStatusBar,
            };

            // 该方法仅在安卓设备有效，ios方法待扩展.callNative(JSON.stringify(data));
            setStatusBar(statusBarParams);
          }
        }
      },
      {
        immediate: true,
      },
    );

    return {
      handleBack,
      navbarRef,
      androidStatusHeight,
    };
  },
});
